import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function WhatsImportant() {

    const feed = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    return (
        <div className='flex flex-col mt-10'>
            <div className="self-start text-3xl font-bold text-right whitespace-nowrap text-zinc-900">
                ما يهمك في فلسطين
            </div>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 mt-8">
                {/* Second Card */}
                {feed.filter((item, index) => index < 4).map((filteredItem, index) => (

                    <div className="flex flex-col">
                        <div className="grow p-2 bg-white rounded-2xl border border-solid border-zinc-300 md:mt-5">
                            <div className="flex flex-row gap-5">
                                <div className="flex flex-col">
                                    <LazyLoadImage
                                        loading="lazy"
                                        srcSet="https://s3-alpha-sig.figma.com/LazyLoadImage/2633/60a7/b97110c7d0995011121ff0a21bccbd80?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Inpr7RUgZZhy4dfQwR~jhMWannOKqdUaSbZOTOgPQXJgkmMoX1KCA-qz-RSOUvel2OHv7l~GY1e157fIlzOB8wpwMCgHHjn1HMmHw~p2TypandDDDM3ffUw5NOKdBHtuO5hY-fmTVP6ymlQdomyQD-Ist-S7Demj9A5HIHcLchEAF7TDdTU2cdVIgprwmm1ApnAEVBvzOpM1PGEpABooAlqSv6gy~nD2eRcbuHjHVJJ7-KJEs3yzRosqOc~eKMLUBr76cW3t-RXCpxgb-Rgi1rzKOX0ggKBiHLe2s5TUr~zvQKaMyVWzoAjv6JWjXV-LoYWuPOgG2IfOpVuaWTupFQ__"
                                        className="grow aspect-[1.3] object-cover rounded-lg"
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <div className="flex flex-col grow self-stretch pt-5 pb-12 bg-white bg-opacity-70">
                                        <div className="justify-center self-start px-2.5 py-1 mr-4 text-sm font-medium tracking-normal leading-3 text-center text-yellow-700 uppercase whitespace-nowrap bg-amber-100 rounded-xl border-yellow-700 border-solid aspect-[2.44] border-[0.5px] md:mr-2.5">
                                            إغاثة
                                        </div>
                                        <div className="flex flex-col px-4 mt-3 text-right">
                                            <div className="text-xl font-bold text-zinc-900">
                                                التحديات الإنسانية في فلسطين , معركة من أجل العيش الكريم
                                            </div>
                                            <div className="self-start mt-3 text-sm whitespace-nowrap text-stone-900">
                                                18 April 2023
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default WhatsImportant